import { downloadCSV } from 'react-admin';
// @ts-ignore
import jsonExport from 'jsonexport/dist';

export const createSacopExporter = (filename: string, headersMap: { [key: string]: (record: any) => any }) => {
    return (records: any[]) => {
        const cleanRecords = records.map(record => {
            const mapped: any = {};
            for (const [header, mapper] of Object.entries(headersMap)) {
                try {
                    mapped[header] = mapper(record);
                } catch (e) {
                    mapped[header] = '';
                }
            }
            return mapped;
        });
        jsonExport(cleanRecords, {
            headers: Object.keys(headersMap)
        }, (err, csv) => {
            if (csv) {
                downloadCSV(csv, filename);
            }
        });
    };
};

// Exporter estándar para Solicitud de Acción (incluye Centro de Costo)
export const defaultSacopExporter = createSacopExporter('Solicitudes_SACOP', {
    'Solicitud Nro': record => record.id,
    'Origen': record => record.motive?.motiveName || '',
    'Centro de Costo': record => record.localization?.name || '',
    'Fecha Emisión': record => record.dateRequestAction ? new Date(record.dateRequestAction).toLocaleDateString() : '',
    'Fecha Vencimiento': record => record.expirationDateAction ? new Date(record.expirationDateAction).toLocaleDateString() : '',
    'Estado Acción': record => record.closingStatus?.statusName || 'Pendiente',
    'Estado Verificación': record => record.verificationStatus?.statusName || 'Pendiente',
});

// Exporter para Análisis, Implementación, Cierre, Verificación y Maestro (no incluye Centro de Costo)
export const standardSacopExporter = createSacopExporter('Listado_SACOP', {
    'Solicitud Nro': record => record.id,
    'Origen': record => record.motive?.motiveName || '',
    'Fecha Emisión': record => record.dateRequestAction ? new Date(record.dateRequestAction).toLocaleDateString() : '',
    'Fecha Vencimiento': record => record.expirationDateAction ? new Date(record.expirationDateAction).toLocaleDateString() : '',
    'Estado Acción': record => record.closingStatus?.statusName || 'Pendiente',
    'Estado Verificación': record => record.verificationStatus?.statusName || 'Pendiente',
});

// Exporter para el Maestro de Acciones (6 columnas por defecto)
export const masterOfSharesExporter = createSacopExporter('Maestro_De_Acciones', {
    'Solicitud Nro': record => record.id,
    'Generador': record => record.typeOfGeneratingEntity?.nameOfGeneratingEntity || '',
    'Origen': record => record.motive?.motiveName || '',
    'Normativa Reglamento u Otro': record => record.regulation?.regulationName || '',
    'Fecha Emisión': record => record.dateRequestAction ? new Date(record.dateRequestAction).toLocaleDateString() : '',
    'Estado Acción': record => record.closingStatus?.statusName || 'Pendiente',
});

// Exporter para el Comité de Acción (12 columnas)
export const sharesCommiteeExporter = createSacopExporter('Comite_De_Accion', {
    'Solicitud Nro': record => record.id,
    'Generador': record => record.typeOfGeneratingEntity?.nameOfGeneratingEntity || '',
    'Origen': record => record.motive?.motiveName || '',
    'Fecha Emisión': record => record.dateRequestAction ? new Date(record.dateRequestAction).toLocaleDateString() : '',
    'Fecha de Análisis': record => record.dateOfFormationOfWorkTeam ? new Date(record.dateOfFormationOfWorkTeam).toLocaleDateString() : '',
    'Fecha Implementación': record => record.implementationDate ? new Date(record.implementationDate).toLocaleDateString() : '',
    'Fecha de Cierre': record => record.closeDate ? new Date(record.closeDate).toLocaleDateString() : '',
    'Fecha de Verificación': record => record.verificationDate ? new Date(record.verificationDate).toLocaleDateString() : '',
    'Fecha Vencimiento': record => record.expirationDateAction ? new Date(record.expirationDateAction).toLocaleDateString() : '',
    'Monto Valorización': record => record.valuationAmount !== undefined && record.valuationAmount !== null ? `$${record.valuationAmount}` : '',
    'Estado Acción': record => record.closingStatus?.statusName || 'Pendiente',
    'Estado Verificación': record => record.verificationStatus?.statusName || 'Pendiente',
});

// Exporter específico para el Dashboard / SacopList
export const sacopDashboardExporter = createSacopExporter('Dashboard_SACOP', {
    'Solicitud Nro': record => record.id,
    'Origen': record => record.motive?.motiveName || '',
    'Fecha Emisión': record => record.dateRequestAction ? new Date(record.dateRequestAction).toLocaleDateString() : '',
    'Fecha Cierre': record => record.closeDate ? new Date(record.closeDate).toLocaleDateString() : '',
    'Fecha Última Actualización': record => record.dateLastUpdated ? new Date(record.dateLastUpdated).toLocaleDateString() : '',
    'Análisis': record => record.sendToResponsibleForAnalysis ? 'Sí' : 'No',
    'Implementación': record => record.sendToResponsibleForImplementation ? 'Sí' : 'No',
    'Cierre': record => record.sendToResponsibleForClosingOfActions ? 'Sí' : 'No',
    'Verificación': record => record.sendToResponsibleForVerificationEffectivenessAction ? 'Sí' : 'No',
    'Estado Acción': record => record.closingStatus?.statusName || 'Pendiente',
    'Estado Verificación': record => record.verificationStatus?.statusName || 'Pendiente',
    'Responsable': record => record.responsible || '',
});
